// extracted by mini-css-extract-plugin
export default {"banner":"tjUpC","logo":"Ylh-i","text":"PLIva"};